tetloose.content = function () {
    var $t = $('[rel=js-clean], .js-clean, .content'),
        $img = $t.find('p img'),
        $p = $t.find('p'),
        $iFrame = $t.find('iframe');

    var $br = $('[rel=js-clean-br], .js-clean-br');

    $br = $br.find('br');

    $br.remove();

    // $img.unwrap();

    $p.filter(function() {
        var $t = $(this),
            html = $t.html();

        if (html === '' || html === '&nbsp;') {
            $t.remove();
        }
    });

    if ($iFrame.length) {
        $iFrame.each(function() {
            var $t = $(this);

            $t.wrap( "<div class='content__iframe'></div>" );
        });
    }

    var $contentIframe = $('.content__iframe');

    if ($contentIframe) {
        $contentIframe.each(function() {
            var $t = $(this),
                $parent = $t.parent();

            if ( $parent.is('p') ) {
                $t.unwrap();
            }
        });
    }
};
